//Import all frontend scripts here

// header
import { headerInit } from './components/header';

// property map
import { propertyMapInit } from './components/property-map';

// apartment selection
import { apartmentSelectionInit } from './components/apartment-selection';

headerInit();
propertyMapInit();
apartmentSelectionInit();
